import { render, staticRenderFns } from "./ManageDetail.vue?vue&type=template&id=f5c12ed2&"
import script from "./ManageDetail.vue?vue&type=script&lang=js&"
export * from "./ManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManageDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ManageDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports